__webpack_require__.p = "/word-instruction/";